import { calculateQuotationTotal } from "@cyh/contracts";

type DraftAmount = number | "";

/** Match the saved PI rule: round each quantity × unit price line, then sum the group to cents. */
export function quotationGroupTotal(lines: ReadonlyArray<{ quantity: DraftAmount; unitPrice: DraftAmount }>): number {
  return calculateQuotationTotal(lines.map((line) => ({
    quantity: line.quantity === "" ? 0 : line.quantity,
    unitPrice: line.unitPrice === "" ? 0 : line.unitPrice
  })));
}
